<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>账单管理</el-breadcrumb-item>
        <el-breadcrumb-item>专项服务</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange">
        <el-radio-button label="1">专项人力</el-radio-button>
        <el-radio-button label="2">专项工作</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 根据tabPosition动态切换组件 -->
    <SpecialManpower v-if="tabPosition === '1'" />
    <SpecialWork v-else />
  </div>
</template>

<script>
import SpecialManpower from './components/SpecialManpower.vue';
import SpecialWork from './components/SpecialWork.vue';

export default {
  name: 'SpecialBill',
  components: {
    SpecialManpower,
    SpecialWork,
  },
  data() {
    return {
      tabPosition: '2',
    };
  },
  methods: {
    handleTabChange() {
      // 切换标签时不需要额外处理，因为子组件会自动处理自己的数据
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
.search-form {
  width: 100%;
}
.search-button {
  display: flex;
  justify-content: flex-end;
}
.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
</style>